/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
export const IFluidTokenProvider = "IFluidTokenProvider";
//# sourceMappingURL=tokenProvider.js.map